import { IPaymentCreationError } from '../models/i-payment-models';

export interface IPaymentCreationErrorToast {
  key: string;
  params?: Record<string, any>;
}

const PREFIX = 'notifications.error.paymentCreation.';

export function getPaymentCreationErrorToast(error: IPaymentCreationError | null | undefined): IPaymentCreationErrorToast {
  if (!error) {
    return { key: PREFIX + 'message' };
  }

  const { type } = error;

  if (type === 'DELIVERY_IS_UNAVAILABLE') {
    return { key: PREFIX + 'deliveryIsOutdatedMessage' };
  }

  if (type === 'MIN_DELIVERY_PRICE_NOT_ALLOWS_DELIVERY') {
    return {
      key: PREFIX + 'deliveryIsNotAvailableDueToCartPrice',
      params: { minPrice: error.minCartPriceAllowsDelivery },
    };
  }

  if (type === 'OUT_OF_STOCK') {
    return {
      key: PREFIX + 'outOfStock',
      params: { count: (error.products || []).length },
    };
  }

  return { key: PREFIX + 'message' };
}
